import React from 'react'
import styles from './index.module.css'
import Header from '../../components/Header'
import Footer from '../../components/Footer'

export default function About() {
	const shortMovieLink =
		'https://www.ardmediathek.de/video/zwischen-spessart-und-karwendel/unbekannte-landschaftsmaler-aus-grainau/br-fernsehen/Y3JpZDovL2JyLmRlL3ZpZGVvLzk4N2QzNmVlLTlmOGItNDc3MS1iNDgyLWQ3NjcxYzEyODljMQ'
	const shortMovieDisplay =
		'https://www.ardmediathek.de/video/zwischen-spessart-und-karwendel/unbekannte-landschaftsmaler-aus-grainau/br-fernsehen/...'

	return (
		<div id='page-container'>
			<Header />
			<div id={styles.aboutText} lang='de'>
				<h2>Das Projekt</h2>

				<p>
					<b>
						„Bär und Lilie“ – Verein zur Erforschung und Erhaltung der Grainauer
						Ortsgeschichte e.V.
					</b>
					, mit Sitz in Grainau, hat sich 2016 dazu entschieden, ein{' '}
					<b>Langzeitprojekt</b> anzugehen.
					<br />
					Es trägt den <u>Arbeitstitel</u>{' '}
					<span style={{ color: '#409dc2' }}>
						„Grainauer Maler – Grainau-Maler“
					</span>
					. Ein kleines Team von mehreren Mitgliedern ist verantwortlich für die
					Durchführung. Die Idee stammt von Dr. Wolfgang Ollendorff, Kassenwart
					des Vereins, der zusammen mit Helmut Lorenz, Beisitzer, auch die
					treibende Kraft ist.
				</p>

				<ol>
					<li>
						Das Projekt beinhaltet die <b>Suche nach Bildern</b> aller Art und
						jeden Alters in den Haushalten von Grainau und Umgebung, gemalt
						<br />
						a) von hier wohnenden Malern („Grainauer Maler“) oder
						<br />
						b) von Künstlern, die zu Studienzwecken, aus Urlaubsgründen oder zur
						Motivsuche nach Grainau kamen bzw. kommen („Grainau-Maler“).
						<br />
						Alle Bilder werden fotografiert und vermessen, die digitalen Fotos
						bearbeitet und anschließend alle Daten in eine Datenbank eingegeben
						(siehe 3.). Eventuell zugehörige Informationen, wie z.B. Provenienz,
						Kaufpreise, Ausstellungen oder Histörchen, werden ebenfalls erfasst.
					</li>

					<li>
						Ein großes Problem stellen die <b>Biografien</b> dar, besonders der
						heimischen oder unbekannten Künstler. Hier ist eine Menge an
						Recherchearbeit nötig. In manchen Fällen kommt man zu keinen oder
						nur sehr mageren Ergebnissen. Die Biografien werden ebenfalls
						sukzessive in die Datenbank eingegeben.
					</li>

					<li>
						Zur <b>Datenbank</b>:
						<ul>
							<li>
								a) <b>Anforderungen</b>: Klare und übersichtliche Optik,
								einfache Bedienerführung, kurze Einarbeitungszeit,
								Erweiterbarkeit auf andere Kunstgegenstände, z.B. Post- und
								Künstlerkarten, Fotos und Dias, Sterbebildchen, Dokumente und
								Bücher, Schnitzereien und Skulpturen, oder auf Gegenstände aus
								früheren Zeiten des täglichen Bedarfs, der Land- und
								Forstwirtschaft und des Handwerks, die fotografiert oder
								gescannt werden.
							</li>

							<li>
								b) <b>Historie</b>: Zum Einstieg wurde durch den Kollegen Peter
								Kuhn aus München in den Jahren 2018 und 2019 ein frei
								zugängliches Datenbankprogramm von Libre Office als{' '}
								<b>Offline-Einzelplatzversion</b> an die erforderlichen Zwecke
								angepasst. Im Herbst 2021 wurde als Zwischenlösung diese
								Datenbank mitsamt Bildordnern auf Google Drive (cloud)
								übertragen, so dass Ideengeber und Programmentwickler immer mit
								den aktuellen Daten arbeiten und testen konnten (nur leider
								nicht gleichzeitig).
							</li>

							<li>
								c) <b>Ziel</b>: Entwicklung einer{' '}
								<b>mehrplatzfähigen Online-Datenbank</b>, zugänglich über eine
								Internetseite mit differenzierten Zugangsberechtigungen, die
								derzeit noch in der Entwicklungs- und Testphase steckt.
								Geplanter Zugang ist zur Jahresmitte 2024 zu erwarten.
							</li>

							<li>
								d) <b>Arbeitsweise</b>: Aktuell gibt es drei Masken zur
								„Daten-Eingabe“ für Besitzer, Künstler und Werke –
								einschließlich Funktionen wie Ändern, Ergänzen, Löschen,
								Vergrößern und Herunterladen - sowie eine „Suchen“-Maske mit
								Ergebnistabelle.
							</li>
						</ul>
					</li>

					<br />

					<li className={styles.lastLi}>
						Auf die <b>Nutzanwendungen</b> wird im Vortrag (siehe 5.)
						ausführlich eingegangen bzw. sind auf der Internetseite im
						Dropdown-Menü vom Button „Das Projekt“ zu finden.
					</li>

					<br />

					<li>
						Weitere <b>Informationen</b> zum Projekt:
						<ul>
							<li>
								a) BR-Kurzfilm von 11 Minuten, gesendet am 7.9.2019 in der Reihe
								„Zwischen Spessart und Karwendel“. <br />
								Zu finden auf Youtube:{' '}
								<a href='https://www.youtube.com/watch?v=3vQ1Jl_7mxU'>
									https://www.youtube.com/watch?v=3vQ1Jl_7mxU
								</a>
							</li>

							<li>
								b) Vortrag von Dr. Ollendorff zum Projekt{' '}
								<a href='/documents/Grainauer_Maler-Grainau-Maler_v5.d_(HVM_14-02-2024)_1-52_ADOBE_XX.pdf'>
									"Grainauer Maler - Grainau Maler"
								</a>
							</li>
						</ul>
					</li>
				</ol>

				<br />
				<br />

				<p>
					Murnau, 21.04.2024
					<br />
					Dr. Wolfgang Ollendorff
				</p>
			</div>
			<Footer />
		</div>
	)
}
